// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__Pw6sC","content":"LayoutSettings_content__2h5v_"};